(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["astranova-email-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-an-email-popup]').forEach((popup) => {
      const storageKey = 'astranova-welcome-offer-closed';
      const repeatDays = Number(popup.dataset.repeatDays) || 14;
      const closedAt = Number(localStorage.getItem(storageKey) || 0);
      const canShow = Date.now() - closedAt > repeatDays * 86400000;
      const success = popup.querySelector('[data-an-popup-success]');
      const open = () => { popup.hidden = false; document.documentElement.style.overflow = 'hidden'; popup.querySelector('input, button')?.focus(); };
      const close = () => { popup.hidden = true; document.documentElement.style.overflow = ''; localStorage.setItem(storageKey, String(Date.now())); };
      popup.querySelectorAll('[data-an-popup-close]').forEach((button) => button.addEventListener('click', close));
      popup.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
      popup.querySelector('[data-an-copy-code]')?.addEventListener('click', async (event) => {
        const button = event.currentTarget;
        await navigator.clipboard?.writeText(button.dataset.anCopyCode);
        const label = button.querySelector('small');
        if (label) label.textContent = 'Copied';
      });
      if (success) open();
      else if (canShow || window.Shopify?.designMode) window.setTimeout(open, Number(popup.dataset.delay) || 5000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["astranova-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-an-hero]').forEach((carousel) => {
      const slides = [...carousel.querySelectorAll('[data-an-slide]')];
      const dots = [...carousel.querySelectorAll('[data-an-dot]')];
      if (slides.length < 2) return;
      let active = 0;
      let timer;
      const autoplay = carousel.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const interval = Number(carousel.dataset.interval) || 7000;
      const show = (next) => {
        active = (next + slides.length) % slides.length;
        slides.forEach((slide, index) => { const selected = index === active; slide.classList.toggle('is-active', selected); slide.setAttribute('aria-hidden', selected ? 'false' : 'true'); });
        dots.forEach((dot, index) => { const selected = index === active; dot.classList.toggle('is-active', selected); dot.setAttribute('aria-selected', selected ? 'true' : 'false'); });
      };
      const stop = () => window.clearInterval(timer);
      const start = () => { stop(); if (autoplay) timer = window.setInterval(() => show(active + 1), interval); };
      carousel.querySelector('[data-an-prev]')?.addEventListener('click', () => { show(active - 1); start(); });
      carousel.querySelector('[data-an-next]')?.addEventListener('click', () => { show(active + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.anDot)); start(); }));
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["astranova-home-portals"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-an-portals]').forEach((section) => {
      const items = [...section.querySelectorAll('[data-an-portal-item]')];
      const media = [...section.querySelectorAll('[data-an-portal-media]')];
      const activate = (index) => {
        items.forEach((item, itemIndex) => { const selected = itemIndex === index; item.classList.toggle('is-active', selected); item.querySelector('[role="tab"]')?.setAttribute('aria-selected', selected ? 'true' : 'false'); });
        media.forEach((element, mediaIndex) => element.classList.toggle('is-active', mediaIndex === index));
      };
      items.forEach((item, index) => {
        item.querySelector('[data-an-portal-trigger]')?.addEventListener('click', () => activate(index));
        item.addEventListener('mouseenter', () => { if (window.matchMedia('(min-width: 750px)').matches) activate(index); });
        item.addEventListener('focusin', () => activate(index));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
